/**
 * PostHog product/traffic analytics — cookieless, production-only.
 *
 * Design (see .claude/TODO/Web-Traffic-Analytics-SEO-IMPL-Workflow.md):
 *  - Key/host injected at build time via REACT_APP_POSTHOG_KEY / _HOST (Dockerfile build args).
 *    The PostHog *project* key is public/client-side — safe to bake into the bundle.
 *  - persistence: 'memory' → cookieless → no cookie-consent banner required (KR/PIPA-safe).
 *  - Prod-gated + localhost-guarded so dev traffic never pollutes the stats.
 *  - Events carry NO PII (event name only).
 */
import posthog from 'posthog-js';

let started = false;

export function initAnalytics() {
  if (started) return;

  const key = process.env.REACT_APP_POSTHOG_KEY;
  const host = process.env.REACT_APP_POSTHOG_HOST || 'https://us.i.posthog.com';

  // Only run in a real production build with a configured key.
  if (process.env.NODE_ENV !== 'production' || !key) return;

  // Never send from local/dev hosts even if a prod bundle is opened there.
  if (typeof window !== 'undefined') {
    const h = window.location.hostname;
    if (h === 'localhost' || h === '127.0.0.1' || h === '') return;
  }

  posthog.init(key, {
    api_host: host,
    capture_pageview: true, // auto pageviews + SPA route changes
    persistence: 'memory', // cookieless → no consent banner
    disable_session_recording: true, // out of scope for now
    autocapture: false, // pageviews + explicit events only (smaller footprint)
  });
  started = true;
}

/**
 * Capture a named event. No-ops safely in dev / before init / on error —
 * analytics must never break the app or the calling flow.
 */
export function capture(event, props) {
  try {
    if (started) posthog.capture(event, props);
  } catch {
    /* swallow — analytics is best-effort */
  }
}
